import { Component } from '@angular/core';
import { NavbarPrimaryComponent } from '../../components/navbar-primary/navbar-primary.component';
import { FooterPrimaryComponent } from '../../components/footer-primary/footer-primary.component';

@Component({
  selector: 'app-not-found',
  imports: [NavbarPrimaryComponent, FooterPrimaryComponent],
  templateUrl: './not-found.component.html',
  styles: `
    :host {
      height: 100vh;
      display: flex;
      flex-direction: column;
    }

    main {
      flex: 1;
      padding-top: 64px;
    }
  `
})
export class NotFoundComponent {}
